import * as ACTIONS from "./types"
import { devices } from "../../models/devices"
import { handleErrors } from "../../utils/file_handling"

export const loadDevices = () => dispatch => {
  // First flag that we're beginning to fetch data
  dispatch(device_fetch_begin())

  fetch("./images/model/devices.json")
    .then(handleErrors)
    .then(data => data.json())
    .then(_data => devices)
    .then(data => {
      // Devices are in the format:
      // [
      //   {DEVICE_TYPE}: [
      //     {
      //       name, id, img
      //     }
      //   ]
      // }
      //
      // We want them aligned by ID

      const flattenedDeviceData = Object.keys(data).reduce((devices, type) => {
        const newDevices = data[type].reduce(
          (agg, { id, img, name, rating, availableColors, details }) => {
            return {
              ...agg,
              [id]: { name, img, type, rating, availableColors, details }
            }
          },
          {}
        ) // an object where id the key for each device for a given type

        return { ...devices, ...newDevices }
      }, {})

      dispatch(device_fetch_success(flattenedDeviceData))
    })
    .catch(err => dispatch(device_fetch_failed(err)))
}

const device_fetch_begin = () => ({
  type: ACTIONS.FETCH_DEVICES_BEGIN
})

const device_fetch_success = data => ({
  type: ACTIONS.FETCH_DEVICES_SUCCESS,
  payload: data
})

const device_fetch_failed = err => ({
  type: ACTIONS.FETCH_DEVICES_FAILURE,
  payload: err
})
